import { useAuthController } from '@/features/auth/controller/auth.controller';
import { useMatchSyncFlush } from './useMatchSyncFlush';
import { useTeamListWarmup } from './query/useTeamListWarmup';

function SignedInSync() {
  useMatchSyncFlush();
  useTeamListWarmup();
  return null;
}

/**
 * Sends the device's queue from any screen once signed in: a match left with
 * actions still queued used to wait for the next live entry or resume, its
 * stats incomplete meanwhile (VOL-208). Also loads the coach's teams for the
 * offline read cache (VOL-14).
 */
export function BackgroundSync() {
  const userId = useAuthController((s) => s.user?.id ?? null);
  // Keyed by user: another account signing in on the tablet sends its own queue.
  return userId ? <SignedInSync key={userId} /> : null;
}
